export const METRICS_HINT_STEPS = {
  aiDetection: {
    element: '[data-testid="metrics-ai-detection-card"]',
    popover: {
      title: "Average AI Detection",
      description:
        "Average AI-generated content likelihood detected across assignments in the selected scope and time period.",
      side: "top",
      align: "center",
    },
  },

  plagiarism: {
    element: '[data-testid="metrics-ai-detection-card"]',
    popover: {
      title: "Average Plagiarism Detection",
      description:
        "Average potential plagiarism detected across assignments in the selected scope and time period.",
      side: "top",
      align: "center",
    },
  },

  classPerformance: {
    element: '[data-testid="metrics-class-performance-card"]',
    popover: {
      title: "Class Performance Trends",
      description:
        "Breaks down student performance across assignments, time periods, or other groupings.",
      side: "top",
      align: "center",
    },
  },

  studentGrowth: {
    element: '[data-testid="metrics-student-trajectories-card"]',
    popover: {
      title: "Student Growth Trajectories",
      description:
        "Student growth trajectories show how a student's writing scores change from one assignment to the next.",
      side: "top",
      align: "center",
    },
  },

  writingSkills: {
    element: ".metrics-writing-skills",
    popover: {
      title: "Writing Skills Trajectory",
      description:
        "Writing skill trajectories show how specific skills trend across assignments based on student performance.",
      side: "top",
      align: "center",
    },
  },

  averageScore: {
    element: '[data-testid="metrics-average-score-card"]',
    popover: {
      title: "Average Score",
      description:
        "Average writing scores across assignments in the selected scope and time period.",
      side: "top",
      align: "center",
    },
  },
};
